/**
 * Attach uuid to id
 * @param  {string} id - model id
 * @param  {object} uuid - threejs model id
 */
export const saveUUID = (id, uuid) => ({
  type: 'SAVE_UUID',
  id,
  uuid,
});

export const saveUUIDs = (uuids) => ({
  type: 'SAVE_UUIDS',
  uuids,
});
